

import { jitsiLocalStorage } from '@jitsi/js-utils';

import { updateSettings } from '../settings';

import { JWT_STORAGE, SET_ACCESS_TOKEN, SET_JWT, SET_RENDER_CONTENT } from './actionTypes';

/**
 * Stores a specific JSON Web Token (JWT) into the redux store.
 *
 * @param {string} [jwt] - The JSON Web Token (JWT) to store.
 * @returns {{
 *     type: SET_TOKEN_DATA,
 *     jwt: (string|undefined)
 * }}
 */
export function setJWT(jwt: ?string) {
    return {
        type: SET_JWT,
        jwt
    };
}

/**
 * Stores a specific JSON Web Token (JWT) into the redux store.
 *
 * @param {string} [jwtData] - The JSON Web Token (JWT) to store.
 * @returns {{
 *     type: SET_TOKEN_DATA,
 *     jwt: (string|undefined)
 * }}
 */
export function setJwtStorage(jwtData: ?string) {
    return {
        type: JWT_STORAGE,
        jwtData
    };
}

/**
 * Render element based on the api.
 *
 * @param {string} shouldRender - The JSON Web Token (JWT) to store.
 *  @returns {{
 *     type: SET_TOKEN_DATA,
 *     jwt: (string|undefined)
 * }}
 */
export function setRenderContent(shouldRender: ?boolean) {
    return {
        type: SET_RENDER_CONTENT,
        shouldRender
    };
}


/**
 * Sets Access Token.
 *
 * @param {any} token:?string - Token.
 * @returns {any}
 */
export function setAccessToken(token: ?string) {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: SET_ACCESS_TOKEN,
            accessToken: token });
        jitsiLocalStorage.setItem('accessToken', token);
        dispatch(updateSettings({
            accessToken: token
        }));
    };
}
